import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Script from 'react-load-script';
import './ClickComponent.scss';
import ClickPaymentService from '../../services/ClickPaymentService';

class ClickComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentId: '',
      allowRedirect: false,
      storeCard: true,
    };
    this.initialised = false;
    this.clickEventHandler = this.clickEventHandler.bind(this);
    this.preInputValid = true;
  }

  componentWillMount() {
    if (window.paymarkPlugin !== undefined) {
      this.initialised = true;
    }
  }

  componentDidMount() {
    this.initializePaymentGateway();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.paymentId !== this.state.paymentId) {
      this.shouldUpdatePaymentId = true;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.clickEventHandler);
  }


  getSettings(paymentId) {
    return {
      redirect: this.state.allowRedirect,
      targetElementId: 'card-container',
      paymentId,
      genericErrorMessage: 'unexpected error occured, please try again later',
      storeCardMethod: this.state.storeCard ? 'STORE_CARD' : 'DO_NOT_STORE_CARD',
      styles: `
        .formWrapper__overlay {
          background-color: transparent;
        }
      `,
      onError: (e) => {
          /* callback when an error occurs*/
        console.log('initalise click failed', e);
      },
    };
  }

  getScriptSrc = () => {
    if (this.isProduction()) {
      return 'https://clickcustompay.paymark.co.nz/paymarkPlugin.js';
    }
    return 'https://clickcustompay.uat.paymark.nz/paymarkPlugin.js';
  };

  isProduction = () => {
    const pattern = /^(www\.broadbandunlimited\.nz|broadbandunlimited\.nz|www\.preprod\.broadbandunlimited\.nz|preprod\.broadbandunlimited\.nz)/;
    return pattern.test(window.location.hostname);
  };

  updateClickError = (code) => {
    const error = {
      100: 'Oops, looks like your card has declined. Give it another go or use a different card.',
      101: 'Oh, that\'s not right, something happened on our end. Please try again.',
      102: 'Oh, that\'s not right, something happened on our end. Please try again.'
    };
    this.props.updateClickErrorMessage({
      error: true,
      errorMessage: error[code]
    });
    this.props.storeClickGatewayDetails({
      clickStatus: true,
    });
  }

  initializePaymentGateway() {
    this.props.updateClickErrorMessage({ error: false, errorMessage: '' });
    this.setState({ paymentId: '' });
    this.props.storeClickGatewayDetails({
      clickStatus: true,
    });
    let transactionTypeValue = 'PURCHASE';
    if (this.props.amount === 0) {
      transactionTypeValue = 'REGISTER';
    }
    const data = {
      transactionType: transactionTypeValue,
      amount: this.props.amount,
      particulars: this.props.email,
      accountNumber: this.props.toAddress.tui,
      lineNumber: this.props.contactNumber,
      merchantOrderId: ''
    };
    ClickPaymentService.fetchPaymentIdClick(data).then(
      (response) => {
        if (response.result === null) {
          this.updateClickError(102);
          return;
        }
        this.setState({
          paymentId: response.result.id
        });
        if (!this.initialised) {
          window.paymarkPlugin.initialise(this.getSettings(response.result.id));
          this.initialised = true;
        } else {
          window.paymarkPlugin.updatePaymentId(response.result.id);
        }
        window.paymarkPlugin.renderCard();
        document.getElementById('paymentIframe').setAttribute('scrolling', 'no');
      }
    );
  }

  initialised = false;
  // currentPaymentID=this.state.paymentId || '';
  shouldUpdatePaymentId=true;

  clickEventHandler = (event) => {
    const message = event.data;
    const { event: paymentEventType, data } = message;
    if (paymentEventType === 'payment_submitted') {
    // handle event here
      console.log('payment is submitted');
    }
    if (paymentEventType === 'payment_challenged') {
    // handle event here
    }
    if (paymentEventType === 'payment_challenge_response') {
    // handle event here
      console.log(data, 'payment_challenge_response');
      if (data.status === 'failure') {
        this.updateClickError(101);
      }
    }

    if (paymentEventType === 'payment_submission_response') {
    // handle event here
      if (data.status === 'approved') {
        ClickPaymentService.validateClickPayment(data.id).then(
          (resp) => {
            if (resp.result.status === 'approved') {
              const clickDetails = {
                clickStatus: true,
                clickTokenId: resp.result.clickTokenId,
                clickTransactionId: resp.result.clickTransactionId,
                clickSessionId: resp.result.clickSessionId
              };
              this.props.storeClickGatewayDetails(clickDetails);
              this.props.callback(clickDetails);
            } else {
              this.updateClickError(100);
            }
          });
      } else {
        this.updateClickError(100);
      }
    }

    if (paymentEventType === 'payment_input') {
    // handle event here
      if (this.preInputValid !== data.valid) {
        this.preInputValid = data.valid;
        this.props.storeClickGatewayDetails({
          clickStatus: !data.valid
        });
      }
    }

    if (paymentEventType === 'payment_expired') {
    // handle event here
    }

    if (paymentEventType === 'payment_id_invalid') {
    // handle event here
    }
  };

  handleScriptLoad = () => {
    if (this.initialised) {
      return;
    }
    window.onmessage = this.clickEventHandler;
  };

  handleScriptError = (e) => {
    console.log('script loaded faild', e);
  };

  render() {
    return (<div className="main-wrapper">
      <Script
        url={this.getScriptSrc()}
        onLoad={this.handleScriptLoad}
        onError={e => this.handleScriptError(e)}
      />
      <div className="main-content">
        <div className="iframe-wrapper">
          {this.props.clickErrorStatus.error &&
            <div className="error-card-container">{this.props.clickErrorStatus.errorMessage}
              <div className="try-again-btn-wrapper" >
                <button
                  className="btn btn-default"
                  onClick={() => this.initializePaymentGateway()}
                >Try Again</button>
              </div>
            </div>
          }
          <div id="card-container">&nbsp;</div>
        </div>
      </div>
    </div>);
  }
}

ClickComponent.propTypes = {
  amount: PropTypes.number,
  toAddress: PropTypes.object,
  contactNumber: PropTypes.string,
  email: PropTypes.string,
  storeClickGatewayDetails: PropTypes.func,
  callback: PropTypes.func,
  updateClickErrorMessage: PropTypes.func,
  clickErrorStatus: PropTypes.object
};

export default ClickComponent;



/** WEBPACK FOOTER **
 ** ./src/components/clickPayment/ClickComponent.js
 **/